import * as actionTypes from "./actionTypes";
import vediAPI from "../../utils/vedi-api/vediAPI";

export const setLicencia = (data) => ({
  type: actionTypes.SET_LICENCIA_DOCUMENTS,
  data,
});

export const setDocuments = ({ data, cuil }) => ({
  type: actionTypes.SET_DOCUMENTS,
  payload: { data, cuil },
});

export const fetchDocumentosApi = async (
  cuil,
  isRepresentacionLegal = false
) => {
  const url = isRepresentacionLegal
    ? "v3/Usuario/DocumentosByCuit"
    : "v3/Usuario/DocumentosByCuil";

  const header = isRepresentacionLegal
    ? { "--Cuit": cuil }
    : { "--Cuil": cuil };

  const { data } = await vediAPI.get(url, {
    headers: {
      ...header,
    },
  });

  return data?.return?.data || {};
};

export const fetchDocumentos = (cuil, isRepresentacionLegal = false) => {
  return async (dispatch) => {
    const url = isRepresentacionLegal
      ? "v3/Usuario/DocumentosByCuit"
      : "v3/Usuario/DocumentosByCuil";

    const header = isRepresentacionLegal
      ? { "--Cuit": cuil }
      : { "--Cuil": cuil };

    await vediAPI
      .get(url, {
        headers: {
          ...header,
        },
      })
      .then(({ data }) => {
        dispatch(setDocuments({ data: data.return, cuil }));
      });
  };
};

export const fetchLicenseApi = async (cuil, isLegalRepresentative = false) => {
  const url = "v3/Usuario/LicenciaCIDI";
  const body = isLegalRepresentative ? { cuit: cuil } : { cuil };

  const { data } = await vediAPI.post(url, body);

  return data.return;
};
